import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';

import { ToastController } from 'ionic-angular';
import { AngularFireAuth } from 'angularfire2/auth';

import * as firebase from 'firebase/app';

@Component({
  selector: 'page-contact',
  templateUrl: 'contact.html'
})
export class ContactPage {

  constructor(public navCtrl: NavController,
  	public toastCtrl: ToastController,
    private afAuth: AngularFireAuth ) {

  }


  /*getGeolocation(){
  	    this.geolocation.getCurrentPosition().then((resp) => {
		 // resp.coords.latitude
		 // resp.coords.longitude
		 this.presentToast(resp.coords.latitude);
		}).catch((error) => {
		  this.presentToast('Error getting location');
		});

  }*/
  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top',
      showCloseButton: false
    });
    toast.present();
  }

  signOut() {
    //this.rhynoApi.UserAccountObservableSubscription.unsubscribe();
    this.afAuth.auth.signOut();
  }

  link(){

    var provider = new firebase.auth.GoogleAuthProvider();
    //var provider = new firebase.auth.FacebookAuthProvider();
    //var provider = new firebase.auth.TwitterAuthProvider();
    //var provider = new firebase.auth.GithubAuthProvider();

    this.afAuth.auth.currentUser.linkWithPopup(provider).then(function(result) {
      // Accounts successfully linked.
      //var credential = result.credential;
      //var user = result.user;
      console.log(result);
      // ...
    }).catch(function(error) {
      // Handle Errors here.
      console.log(error);
      // ...
    });

  }  

}



// WEBPACK FOOTER //
// ./src/pages/contact/contact.ts